import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      meta: {
        title: '',
        index: 0,
      },
      component: () => import('../page/businesspage/index'),
    },
    {
      path: '/homeCatalog',
      meta: {
        title: '首页',
        index: 1,
      },
      component: () => import('../page/businesspage/homeCatalog/index'),
    },
    {
      path: '/homeCatalog/morePaeg',
      meta: {
        title: '精美图库',
        index: 2,
      },
      component: () => import('../page/businesspage/homeCatalog/progeny/morePaeg'),
    },
    {
      path: '/searchCatalog/index',
      meta: {
        title: '搜索',
        index: 3,
      },
      component: () => import('../page/businesspage/searchCatalog/index'),
    },
    {
      path: '/contactCatalog/index',
      meta: {
        title: '联系',
        index: 4,
      },
      component: () => import('../page/businesspage/contactCatalog/index'),
    },
    {
      path: '/homeCatalog/more',
      meta: {
        title: '',
        index: 25,
      },
      component: () => import('../page/businesspage/homeCatalog/progeny/more'),
    },
    {
      path: '/homeCatalog/moreSecondLevel',
      meta: {
        title: '',
        index: 26,
      },
      component: () => import('../page/businesspage/homeCatalog/progeny/moreSecondLevel'),
    },
    {
      path: '/contactCatalog/progeny/signIn',
      meta: {
        title: '用户登录',
        index: 6,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/signIn'),
    },
    {
      path: '/renew',
      meta: {
        title: '账号续费',
        index: 6,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/renew'),
    },
    {
      path: '/contactCatalog/progeny/information',
      meta: {
        title: '账号信息',
        index: 24,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/information'),
    },
    {
      path: '/contactCatalog/progeny/changePassword',
      meta: {
        title: '修改密码',
        index: 7,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/changePassword'),
    },
    {
      path: '/upgrade',
      meta: {
        title: '账号升级',
        index: 8,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/upgrade'),
    },
    {
      path: '/contactCatalog/progeny/operation',
      meta: {
        title: '操作目录',
        index: 9,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/operation'),
    },
    {
      path: '/uploadPicture',
      meta: {
        title: '图片目录',
        index: 10,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/uploadPicture'),
    },
    {
      path: '/homeCatalog/progeny/turnOver',
      meta: {
        title: '请除缓存',
        index: 11,
      },
      component: () => import('../page/businesspage/homeCatalog/progeny/turnOver'),
    },
    {
      path: '/contactCatalog/progeny/increase',
      meta: {
        title: '新建文件',
        index: 12,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/increase'),
    },
    {
      path: '/contactCatalog/progeny/operationSecondLevel',
      meta: {
        title: '操作目录',
        index: 13,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/operationSecondLevel'),
    },
    {
      path: '/contactCatalog/progeny/increaseEdit',
      meta: {
        title: '编辑目录',
        index: 14,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/increaseEdit'),
    },
    {
      path: '/searchCatalog/progeny/search',
      meta: {
        title: '',
        index: 15,
      },
      component: () => import('../page/businesspage/searchCatalog/progeny/search'),
    },
    {
      path: '/searchCatalog/progeny/video',
      meta: {
        title: '',
        index: 16,
      },
      component: () => import('../page/businesspage/searchCatalog/progeny/video'),
    },
    {
      path: '/searchCatalog/progeny/videoPlayer',
      meta: {
        title: '',
        index: 17,
      },
      component: () => import('../page/businesspage/searchCatalog/progeny/videoPlayer'),
    },
    {
      path: '/searchCatalog/progeny/zoom',
      meta: {
        title: '场景',
        index: 18,
      },
      component: () => import('../page/businesspage/searchCatalog/progeny/zoom'),
    },
    {
      path: '/contactCatalog/progeny/register',
      meta: {
        title: '注册',
        index: 19,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/register'),
    },
    {
      path: '/openaccount',
      meta: {
        title: '账号',
        index: 20,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/openaccount'),
    },
    {
      path: '/renewhui',
      meta: {
        title: '会员续费',
        index: 21,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/renewhui'),
    },
    {
      path: '/adminupgrade',
      meta: {
        title: '账号升级',
        index: 22,
      },
      component: () => import('../page/businesspage/contactCatalog/progeny/adminupgrade'),
    },
    {
      path: '/assembling',
      meta: {
        title: '装配',
        index: 23,
      },
      component: () => import('../page/businesspage/searchCatalog/progeny/assembling'),
    },
    {
      path: '/classifyCatalog',
      meta: {
        title: '工具',
        index: 27,
      },
      component: () => import('../page/businesspage/classifyCatalog/index'),
    },
    {
      path: '/classifyCatalog/upload',
      meta: {
        title: '',
        index: 28,
      },
      component: () => import('../page/businesspage/classifyCatalog/progeny/upload'),
    },
  ],
})
